// @flow

import React from 'react';
import { Form, Checkbox } from 'semantic-ui-react';

type Props = {
  value: boolean,
  onChange: (value: boolean) => void,
};

const QuestionRequiredField = ({ value, onChange }: Props) => {
  const changed = (_, { checked }) => onChange(checked);

  return (
    <Form.Field>
      <Checkbox
        toggle
        label="Réponse obligatoire"
        checked={value}
        onChange={changed}
      />
    </Form.Field>
  );
};

export default QuestionRequiredField;



// WEBPACK FOOTER //
// ./src/modules/survey/components/questions/QuestionRequiredField.js